var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { authService } from '../services/auth-service';
import './jv-login';
import './jv-dashboard';
import './jv-live-view';
import './jv-parent-pages.js';
import './admin/jv-admin-dashboard';
import './admin/jv-admin-cameras';
import './admin/jv-admin-settings';
import './admin/jv-admin-agents';
import './admin/jv-admin-parents';
import './admin/jv-admin-sites';
let JvApp = class JvApp extends LitElement {
    constructor() {
        super(...arguments);
        this._loading = true;
        this._profile = null;
        this._route = 'login';
        this._selectedCameraId = null;
        this._parentPageRoute = '';
    }
    static { this.styles = css `
    :host { display: block; min-height: 100vh; }
    .loading { display: grid; place-items: center; min-height: 100vh; }
    .topbar { background: #3A3530; color: #fff; }
    .tab { color: rgba(255,255,255,.7); font-size: 13px; font-weight: 600; padding: 0 12px; height: 56px; display: flex; align-items: center; cursor: pointer; border-bottom: 2px solid transparent; transition: all .15s; }
    .tab:hover { color: #fff; }
    .tab.active { color: #fff; border-bottom-color: var(--jv-primary, #2B7A9B); }
  `; }
    get _isAdmin() {
        return this._profile?.roles?.includes('TenantAdmin') ?? false;
    }
    connectedCallback() {
        super.connectedCallback();
        this._checkAuth();
    }
    async _checkAuth() {
        this._loading = true;
        if (authService.isAuthenticated()) {
            try {
                this._profile = await authService.getProfile();
                this._route = this._isAdmin ? 'admin' : 'dashboard';
            }
            catch {
                authService.logout();
                this._profile = null;
                this._route = 'login';
            }
        }
        else {
            this._route = 'login';
        }
        this._loading = false;
    }
    _onLoginSuccess(profile) {
        this._profile = profile;
        this._route = profile.roles?.includes('TenantAdmin') ? 'admin' : 'dashboard';
    }
    _onLogout() {
        authService.logout();
        this._profile = null;
        this._route = 'login';
    }
    _onNavigate(e) {
        const { route, cameraId, page } = e.detail;
        this._route = route;
        if (cameraId)
            this._selectedCameraId = cameraId;
        if (page)
            this._parentPageRoute = page;
    }
    _onBackToDashboard() {
        this._route = 'dashboard';
        this._selectedCameraId = null;
        this._parentPageRoute = '';
    }
    _handleViewCamera(e) {
        const cameraId = e.detail?.cameraId;
        if (cameraId) {
            this._selectedCameraId = cameraId;
            this._route = 'live';
        }
    }
    _onAdminNav(e) {
        const r = e.detail.route;
        switch (r) {
            case 'cameras':
                this._route = 'admin-cameras';
                break;
            case 'sites':
                this._route = 'admin-sites';
                break;
            case 'agents':
                this._route = 'admin-agents';
                break;
            case 'parents':
                this._route = 'admin-parents';
                break;
            case 'settings':
                this._route = 'admin-settings';
                break;
            default: this._route = 'admin';
        }
    }
    _switchToParent() { this._route = 'dashboard'; }
    _switchToAdmin() { this._route = 'admin'; }
    _renderAdminTopHeader() {
        return html `
      <span class="inline-flex items-center gap-2 mr-4">
        <span class="grid place-items-center w-7 h-7 rounded-lg bg-jv-primary text-white">
          <svg viewBox="0 0 24 24" class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>
        </span>
        <span class="font-bold text-sm tracking-tight">Just<span class="text-jv-primary">Vue</span></span>
      </span>
      ${this._renderAdminTopbar()}
      <span class="ml-auto text-xs text-white/70">${this._profile.displayName}</span>
      <button @click=${this._onLogout} class="text-xs text-white/70 hover:text-white font-medium transition">Sign out</button>
    `;
    }
    _renderAdminTopbar() {
        if (!this._isAdmin)
            return html ``;
        const isAdminActive = ['admin', 'admin-cameras', 'admin-settings', 'admin-agents', 'admin-parents', 'admin-sites'].includes(this._route);
        return html `
      <span class="tab ${isAdminActive ? 'active' : ''}" @click=${this._switchToAdmin}>School Admin</span>
      <span class="tab ${!isAdminActive ? 'active' : ''}" @click=${this._switchToParent}>Parent View</span>
    `;
    }
    render() {
        if (this._loading) {
            return html `<div class="loading">
        <div class="flex flex-col items-center gap-3">
          <span class="grid place-items-center w-14 h-14 rounded-2xl bg-jv-primary text-white shadow-jv">
            <svg viewBox="0 0 24 24" class="w-7 h-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>
          </span>
          <p class="text-sm text-jv-ink-2">Just<span class="text-jv-primary font-semibold">Vue</span></p>
        </div>
      </div>`;
        }
        switch (this._route) {
            case 'login':
                return html `<jv-login
          @login-success=${(e) => this._onLoginSuccess(e.detail)}
        ></jv-login>`;
            case 'live':
                return html `<jv-live-view
          .profile=${this._profile}
          .cameraId=${this._selectedCameraId}
          @back=${this._onBackToDashboard}
        ></jv-live-view>`;
            case 'parent-page':
                return html `<jv-parent-page
          .route=${this._parentPageRoute}
          @back=${this._onBackToDashboard}
          @open-camera=${this._handleViewCamera}
        ></jv-parent-page>`;
            case 'admin':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-dashboard
            .profile=${this._profile}
            @admin-nav=${this._onAdminNav}
          ></jv-admin-dashboard>
        `;
            case 'admin-cameras':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-cameras @admin-back=${() => this._route = 'admin'}></jv-admin-cameras>
        `;
            case 'admin-settings':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-settings @admin-back=${() => this._route = 'admin'}></jv-admin-settings>
        `;
            case 'admin-agents':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-agents @admin-back=${() => this._route = 'admin'}></jv-admin-agents>
        `;
            case 'admin-parents':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-parents @admin-back=${() => this._route = 'admin'}></jv-admin-parents>
        `;
            case 'admin-sites':
                return html `
          <header class="topbar w-full"><div class="max-w-content mx-auto px-5 sm:px-8 h-14 flex items-center gap-2">${this._renderAdminTopHeader()}</div></header>
          <jv-admin-sites @admin-back=${() => this._route = 'admin'}></jv-admin-sites>
        `;
            case 'dashboard':
            default:
                return html `
          <jv-dashboard
            .profile=${this._profile}
            @logout=${this._onLogout}
            @navigate=${this._onNavigate}
          ></jv-dashboard>
          ${this._isAdmin ? html `
            <div class="max-w-content mx-auto px-5 sm:px-8 pb-8 text-center">
              <button @click=${this._switchToAdmin}
                class="text-sm text-jv-primary font-semibold hover:underline">
                Go to School Admin Dashboard
              </button>
            </div>
          ` : ''}
        `;
        }
    }
};
__decorate([
    state()
], JvApp.prototype, "_loading", void 0);
__decorate([
    state()
], JvApp.prototype, "_profile", void 0);
__decorate([
    state()
], JvApp.prototype, "_route", void 0);
__decorate([
    state()
], JvApp.prototype, "_selectedCameraId", void 0);
__decorate([
    state()
], JvApp.prototype, "_parentPageRoute", void 0);
JvApp = __decorate([
    customElement('jv-app')
], JvApp);
export { JvApp };
